export default {
    slug: 'zohobooks',
    ability: 'zohobooks',
    routes: [],
    integrationRoutes: [
        {
            path: 'zohobooks',
            name: 'settings-zohobooks',
            component: () => import('@modules/SyncZohoBooks/Resources/js/pages/ZohoBooksSettings.vue'),
            meta: { label: 'Zoho Books' }
        }
    ],
    integrationTabs: () => [
        {
            title: i18n.t('Zoho Books'),
            icon: 'book-sync',
            route: 'settings-zohobooks',
            position: 20
        }
    ]
};
